import { render, staticRenderFns } from "./BankImportLog.vue?vue&type=template&id=5666b318&"
import script from "./BankImportLog.vue?vue&type=script&lang=js&"
export * from "./BankImportLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports